module.exports = __webpack_public_path__ + "static/img/my.8bfd547b.svg";